import {
    BackButton,
    classNames,
    layout,
    PushButton,
    typography,
    View,
    ViewContent,
    ViewDescription,
    ViewHeader,
    ViewHeaderItem,
    ViewTitle
} from "@variocube/cube-ui";
import * as React from "react";
import {commonStyles} from "./commonStyles";
import {useLocalization} from "../i18n";
import {useEffect} from "react";
import {soundMachine} from "@variocube/app-host/src/SoundMachine";
import {getSoundByKey} from "../accessibility";

interface PoBoxEmptyViewProps {
    onBack : () => void;
}

export function PoBoxEmptyView({onBack}: PoBoxEmptyViewProps) {
    const {t, language} = useLocalization();

    useEffect(() => {
        soundMachine.play(getSoundByKey('NoDelivery', language));
        const timeout = setTimeout(() => {
            onBack();
        }, 15000);
        return () => {
            clearTimeout(timeout);
        };
    }, [language, onBack]);

    return (
        <View>
            <ViewHeader className={commonStyles.viewHeader}>
                <ViewHeaderItem>
                    <BackButton onClick={onBack} label={t("Back")}/>
                </ViewHeaderItem>
                <ViewHeaderItem fill>
                    <ViewTitle>{t("PickUp")}</ViewTitle>
                    <ViewDescription>{t("PoBoxEmpty")}</ViewDescription>
                </ViewHeaderItem>
            </ViewHeader>
            <ViewContent className={classNames(layout.vertical, layout.center, layout.alignCenter)}>
                <div className={classNames(typography.title, layout.marginLarge)}>
                    {t("PoBoxEmpty")}
                </div>
                <PushButton primary onClick={onBack}>
                    {t("Finish")}
                </PushButton>
            </ViewContent>
        </View>
    );
}
